// @flow
import * as constants from '../constants/appConstants';
import { TYPE as TARGET_TYPE } from '../constants/targetConstants';

type SetSectionAction = {|
    type: typeof constants.SET_SECTION,
    data: null | $Values<typeof constants.SECTION>
|};

type SetTargetAction = {|
    type: typeof constants.SET_TARGET,
    data: null | {
        id: string,
        type: $Values<typeof TARGET_TYPE>
    }
|};

type SetTisEnabledAction = {|
    type: typeof constants.SET_TIS_ENABLED,
    data: boolean
|};

type SetThrottlingIntervalAction = {|
    type: typeof constants.SET_THROTTLING_INTERVAL,
    data: number
|};

export type AppAction =
    | SetSectionAction
    | SetTargetAction
    | SetTisEnabledAction
    | SetThrottlingIntervalAction;


export default {
    setSection: (section: null | $Values<typeof constants.SECTION>): SetSectionAction => ({
        type: constants.SET_SECTION,
        data: section
    }),

    setTarget: (target: null | $ReadOnly<{id: string, type: $Values<typeof TARGET_TYPE>}>): SetTargetAction => ({
        type: constants.SET_TARGET,
        data: target
    }),

    setTisEnabled: (enabled: boolean): SetTisEnabledAction => ({
        type: constants.SET_TIS_ENABLED,
        data: enabled
    }),

    setThrottlingInterval: (interval: boolean): SetThrottlingIntervalAction => ({
        type: constants.SET_THROTTLING_INTERVAL,
        data: interval
    })
};